<template>
  <v-card>
    <div class="d-flex justify-space-between align-center">
      <p class="ma-0 pl-2 pt-4 pb-1">Reportes de usuarios</p>
      <v-sheet max-width="170px">
        <v-select
          class="pa-0 ma-0"
          v-model="filterDateStatus"
          :items="filters"
          hide-details
          @change="changeFilterDate"
        ></v-select>
      </v-sheet>
    </div>
    <v-divider></v-divider>
    <v-container>
      <div v-if="showDatesSelected" class="d-flex align-center justify-end">
        {{ datesSelected.join(" ~ ") }}
        <v-btn x-small class="ma-0 ml-2" @click="showCalendar = true"
          >cambiar</v-btn
        >
      </div>
      <v-row>
        <v-col class="pb-0 text-center" cols="12">
          <v-select
            class="pa-0 ma-0"
            v-model="userSelected"
            :items="userList"
            item-text="name"
            item-value="uid"
            outlined
            dense
            :loading="loadingUsers"
            label="Seleccione un usuario"
            hide-details
            @change="changeFilterDate(filterDateStatus)"
          ></v-select>
        </v-col>
        <v-col
          cols="12"
          class="d-flex justify-center text-center mt-4"
          v-if="loadingAverage"
        >
          <v-progress-circular
            indeterminate
            size="50"
            color="primary"
          ></v-progress-circular>
        </v-col>
        <v-col class="pb-0 text-center" cols="6" v-if="!loadingAverage">
          <v-card
            elevation="0"
            @click="
              $router.push({
                name: 'completedChecklist',
                query: {
                  startAt: globalQuery.startAt,
                  endAt: globalQuery.endAt,
                  status: 'Todos',
                  user: userSelected
                }
              })
            "
          >
            <p>Checklist realizados</p>
            <p class="text-analytics ma-0 text-center green--text">
              {{ userData.completed }}
            </p>
          </v-card>
        </v-col>
        <v-col class="pb-0 text-center" cols="6" v-if="!loadingAverage">
          <v-card
            elevation="0"
            @click="
              $router.push({
                name: 'damagesChecklist',
                query: {
                  startAt: globalQuery.startAt,
                  endAt: globalQuery.endAt,
                  status: 'Damages',
                  user: userSelected
                }
              })
            "
          >
            <p>Incidencias Reportadas</p>
            <p class="text-analytics ma-0 text-center warning--text">
              {{ userData.incidences }}
            </p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="showCalendar" max-width="300" persistent>
      <v-card>
        <div class="d-flex justify-end">
          <v-icon @click="closeCalendar" class="ml-2 mt-1">close</v-icon>
        </div>
        <v-container>
          <v-date-picker
            v-model="datesSelected"
            multiple
            :disabled="datesSelected.length > 1"
          ></v-date-picker>
          <div class="d-flex justify-space-between mt-3">
            <v-btn
              color="primary"
              :disabled="datesSelected.length < 2"
              @click="searchByDatesIncidence"
              >Aceptar</v-btn
            >
            <v-btn color="error" @click="resetDatesIncidence">Borrar</v-btn>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
import { firestore } from "@/config/firebase";

export default {
  data() {
    return {
      filterDateStatus: "Hoy",
      filters: ["Hoy", "Este mes", "Rango de fechas"],
      loadingAverage: false,
      userList: [],
      userSelected: null,
      loadingUsers: true,
      userData: {
        incidences: 0,
        completed: 0
      },

      showCalendar: false,
      showDatesSelected: false,
      datesSelected: [],
      globalQuery: null
    };
  },
  computed: {
    ...mapState("user", ["data"])
  },
  async mounted() {
    this.getUsers();
    const query = {
      userUid: this.data.uid,
      startAt: `${moment().format("YYYY-MM-DD")}`,
      endAt: `${moment()
        .add(1, "days")
        .format("YYYY-MM-DD")}`
    };
    this.userSelected = this.data.uid;
    this.getCompletedData(query);
  },
  methods: {
    ...mapActions("checklist", ["getAnalytics"]),
    async getUsers() {
      const userSnap = await firestore("users").get();
      const data = [];
      for (const user of userSnap.docs) {
        data.push({
          name: user.data().name,
          uid: user.data().uid
        });
      }
      this.userList = data;
      this.loadingUsers = false;
    },
    async getCompletedData(query) {
      this.globalQuery = query;
      this.loadingAverage = true;
      try {
        const responseData = await this.getAnalytics(query);
        const dataFilter = this.getAverageFilter(responseData);
        this.userData = dataFilter;
        this.loadingAverage = false;
      } catch (error) {
        this.loadingAverage = false;
      }
    },
    getAverageFilter(data) {
      const filterIncidence = data.filter(currentData => {
        return currentData.incidence === true;
      });
      return {
        incidences: filterIncidence.length,
        completed: data.length
      };
    },
    async changeFilterDate(value) {
      switch (value) {
        case "Rango de fechas": {
          this.showCalendar = true;
          this.showDatesSelected = true;
          break;
        }
        case "Hoy": {
          const query = {
            userUid: this.userSelected ? this.userSelected : this.data.uid,
            startAt: `${moment().format("YYYY-MM-DD")}`,
            endAt: `${moment()
              .add(1, "days")
              .format("YYYY-MM-DD")}`
          };
          this.getCompletedData(query);
          this.showDatesSelected = false;
          break;
        }
        case "Este mes": {
          const queryMonth = {
            userUid: this.userSelected ? this.userSelected : this.data.uid,
            startAt: `${moment()
              .startOf("month")
              .format("YYYY-MM-DD")}`,
            endAt: `${moment()
              .endOf("month")
              .format("YYYY-MM-DD")}`
          };
          this.getCompletedData(queryMonth);
          this.showDatesSelected = false;
          break;
        }
      }
    },
    // calendar
    searchByDatesIncidence() {
      const queryMonth = {
        userUid: this.userSelected ? this.userSelected : this.data.uid,
        startAt:
          this.datesSelected[0] < this.datesSelected[1]
            ? this.datesSelected[0]
            : this.datesSelected[1],
        endAt:
          this.datesSelected[1] > this.datesSelected[0]
            ? this.datesSelected[1]
            : this.datesSelected[0]
      };
      this.getCompletedData(queryMonth);
      this.showCalendar = false;
    },
    closeCalendar() {
      this.showCalendar = false;
      this.showDatesSelected = false;
      this.filterDateStatus = "Hoy";
      this.changeFilterDateCR("Hoy");
    },
    resetDatesIncidence() {
      this.datesSelected = [];
    }
  }
};
</script>

<style>
.text-analytics {
  font-size: 70px !important;
}
</style>
